export const COMP_BUTTON = 'button';
export const COMP_RADIO_BUTTON = 'radiobutton';
export const COMP_INPUT_TEXT = 'inputtext';
export const COMP_CHECKBOX = 'checkbox';
export const COMP_DROPDOWN = 'selectlist';
export const COMP_ACCORDION = 'accordion';
export const COMP_FORM = 'form';

// import { InteractionData, NavigationData, TaskData, InteractionTypes, NavigationTypes } from '@origin-digital/reporting-client/dist';
// import { AnalyticsEventType } from '@origin-digital/reporting-client/dist/adobeAnalytics';

// type EventBase = {
//     type: string;
//     eventType: AnalyticsEventType;
// }

// interface EventNavigation extends EventBase {
//     type: NavigationTypes | 'page';
//     eventType: 'navigation',
//     data: NavigationData
// };

// interface EventInteraction extends EventBase {
//     type: InteractionTypes;
//     eventType: 'interaction',
//     data: InteractionData
// };

// interface EventTask extends EventBase {
//     eventType: 'task',
//     data: TaskData
// };

// type Event = EventNavigation | EventInteraction | EventTask;

// type Events = {
//     [name: string]: Event
// };

// export type FieldEventType = 'input' | 'radioSelect' | 'pageLoad' | 'submit';

// export default {
//     // -------------------------------------------------------------------------
//     // -------------------------------------------------------------- Navigation
//     // -------------------------------------------------------------------------
//     // Trigger: Step 1 Page load
//     page1Load: {
//         'eventType': 'navigation',
//         'type': 'page',
//         'data': {
//             // TODO: replace with correct url
//             'currentUri': 'www.originenergy.com.au/TBD',
//             'referringUri': '', //Optional
//             'friendlyUri': 'solar:request-a-quote:step1'
//         }
//     },

//     // Trigger: Step 2 Page load
//     page2Load: {
//         'eventType': 'navigation',
//         'type': 'page',
//         'data': {
//             // TODO: replace with correct url
//             'currentUri': 'www.originenergy.com.au/TBD',
//             'referringUri': '', //Optional
//             'friendlyUri': 'solar:request-a-quote:step2'
//         }
//     },

//     // -------------------------------------------------------------------------
//     // -------------------------------------------------------------------- Task
//     // -------------------------------------------------------------------------

//     // Trigger: First focus on any field (first interaction with the form)
//     firstFieldFocus: {
//         'eventType': 'task',
//         'type': 'solar-request-quote',
//         'data': {
//             'action': 'start' //Required
//         }
//     },
//     // Trigger: When the form has been submitted successfully and we got the successful answer from SalesForce
//     submitSuccessful: {
//         'eventType': 'task',
//         'type': 'solar-request-quote',
//         'data': {
//             'action': 'complete', //Required
//             'postcode': '3000', //Required, postcode from the address entered by the user
//             'leadId': '00Q6F00001ASwN0' //Lead ID returned by SalesForce when the form is sent successfully
//         }
//     },

//     // -------------------------------------------------------------------------
//     // ------------------------------------------------------------- Interaction
//     // -------------------------------------------------------------------------

//     // Trigger: Radio button selected in "How can we help you?"
//     radioSelectProductType: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'solar-system', //Required; second component of data-id
//             'parentContainer': 'help', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'solar-system' //Required; Text selected, possible values: ("solar-system", "solar-and-battery-systems", "batteries")
//         }
//     },
//     // Trigger: Radio button selected in "What is your property type?"
//     radioSelectPropertyType: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'unit', //Required; second component of data-id
//             'parentContainer': 'property-type', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'unit' //Required; Text selected, possible values TBD: ("unit", "apartment", "house")
//         }
//     },
//     // Trigger: Radio button selected in "What is your roof made from?"
//     radioSelectRoofType: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'slate', //Required; second component of data-id
//             'parentContainer': 'roof-made', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'slate' //Required; Text selected, possible values TBD: ("slate", "tiles", "concrete")
//         }
//     },
//     // Trigger: Click to the "Next" button to proceed with the form.
//     buttonNext: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_BUTTON, //Required
//             'id': 'next', //Required; second component of data-id
//             'parentContainer': 'step1', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'next' //Required; Text displayed on the button
//         }
//     },
//     // Trigger: User filled the "Average Quarterly Bill" field
//     inputAverageQuarterlyBillCost: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_INPUT_TEXT, //Required
//             'id': 'avg-quarterly-bill', //Required; second component of data-id
//             'parentContainer': 'step2', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': '456.56' //Required; Text introduced and valid, possible values: ("400", "465.23"...)
//         }
//     },
//     // Trigger: Radio button selected in "When do you use the most energy?"
//     radioSelectUsagePercentDuringDay: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'day', //Required; second component of data-id
//             'parentContainer': 'energy-use', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'day' //Required; Text selected, possible values TBD: ("night", "day-night", "day")
//         }
//     },
//     // Trigger: Radio button selected in "How many stories is your house?"
//     radioSelectPropertyStorey: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'single', //Required; second component of data-id
//             'parentContainer': 'house-stories', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'single' //Required; Text selected, possible values TBD: ("single", "double", "plus3")
//         }
//     },
//     // Trigger: Radio button selected in "What is your roof shape?"
//     radioSelectRoofPitch: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'flat', //Required; second component of data-id
//             'parentContainer': 'roof-shape', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'flat' //Required; Text selected, possible values TBD: ("flat", "less30", "more30", "not-sure")
//         }
//     },
//     // Trigger: Radio button selected in "What kind of power does your property have?"
//     radioSelectPowerConnectionPhaseType: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_RADIO_BUTTON, //Required
//             'id': 'single-phase', //Required; second component of data-id
//             'parentContainer': 'property-power', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'single-phase' //Required; Text selected, possible values TBD: ("single-phase", "three-phase", "not-sure")
//         }
//     },
//     // Trigger: Click to the "Request a quote" button to submit the form
//     buttonSubmit: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_BUTTON, //Required
//             'id': 'request-a-quote', //Required; second component of data-id
//             'parentContainer': 'step2', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'request-a-quote' //Required; Text displayed on the button
//         }
//     },
//     // Trigger: Click to the "Back" button to go back in the form.
//     buttonBack: {
//         'eventType': 'interaction',
//         'type': 'click',
//         'data': {
//             'componentType': COMP_BUTTON, //Required
//             'id': 'back', //Required; second component of data-id
//             'parentContainer': 'step2', //Optional; first component of data-id
//             'appName': 'solar-request-a-quote', //Required
//             'label': 'back' //Required; Text displayed on the button
//         }
//     }
// } as Events;
